"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _area = require("@/api/area");
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _permission = require("@/utils/permission");
var _templateDialog = _interopRequireDefault(require("@/views/area/areamenu/templateDialog"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _settingMer = require("@/utils/settingMer");
var _ManagementNotice = _interopRequireDefault(require("@/components/ManagementNotice"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'AreaIndex',
  components: {
    TemplateDialog: _templateDialog.default,
    ManagementNotice: _ManagementNotice.default
  },
  data: function data() {
    return {
      collapse: false,
      listLoading: true,
      tableData: [],
      AssociationDia: {
        visible: false,
        ids: null
      },
      checkedIds: [],
      circlePermiPrefix: "".concat((0, _settingMer.getAdminModule)(), ":circle"),
      routePrefix: (0, _settingMer.getRoutePrefix)()
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    hasCirclePermi: function hasCirclePermi(action) {
      return this.checkPermi(["".concat(this.circlePermiPrefix, ":").concat(action)]);
    },
    canManageCircleMore: function canManageCircleMore() {
      var _this = this;
      return ['update', 'bind', 'conjunctive:diy', 'delete'].some(function (action) {
        return _this.hasCirclePermi(action);
      });
    },
    areaPath: function areaPath(path) {
      return "".concat(this.routePrefix).concat(path);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedIds = (0, _ZBKJIutil.selectionCheckedIds)(val);
    },
    handleClose: function handleClose() {
      this.AssociationDia.visible = false;
    },
    // 关联模板
    handleAssociation: function handleAssociation(row) {
      if (!row && !this.checkedIds.length) this.$message.warning('请先选择商圈');
      this.AssociationDia = {
        ids: row ? row.id : this.checkedIds.join(','),
        visible: true
      };
    },
    // 获取树形列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _area.areaListTreeApi)().then(function (res) {
        // 根据实际返回的数据结构进行处理
        // 如果返回的是分页数据结构
        _this2.tableData = res;
        _this2.listLoading = false;
      }).catch(function (error) {
        console.error('获取店铺分组列表失败:', error);
        _this2.listLoading = false;
      });
    },
    // 重置查询
    resetQuery: function resetQuery() {
      this.queryParams = {
        name: '',
        status: '',
        parentId: '',
        page: 1,
        limit: 20
      };
      this.getList();
    },
    // 新增店铺分组
    // 新增店铺分组
    handleAdd: function handleAdd() {
      var parentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (parentId === 0) {
        // 从顶部按钮进入，新增顶级店铺分组
        this.$router.push(this.areaPath('/area/create'));
      } else {
        // 从某一行进入，新增子店铺分组
        this.$router.push(this.areaPath("/area/create?parentId=".concat(parentId)));
      }
    },
    // 编辑店铺分组
    handleEdit: function handleEdit(row) {
      this.$router.push(this.areaPath("/area/create/".concat(row.id)));
    },
    // 查看店铺分组详情
    handleView: function handleView(row) {
      this.$router.push(this.areaPath("/area/create/".concat(row.id, "?mode=view")));
    },
    // 删除店铺分组
    handleDelete: function handleDelete(id) {
      var _this3 = this;
      this.$confirm('确定删除该店铺分组吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _area.areaDeleteApi)(id).then(function () {
          _this3.$message.success('删除成功');
          _this3.getList();
        });
      });
    },
    // 状态切换
    onchangeIsShow: function onchangeIsShow(row, type) {
      var _this4 = this;
      if (!row.status && type === 'show') {
        this.$message.error('该店铺分组已被禁用，无法显示');
        row.isShow = !row.isShow;
        return;
      }
      var api = type === 'show' ? _area.areaIsShowApi : _area.areaStatusApi;
      api(row.id).then(function () {
        if (type === 'status' && !row.status) {
          row.isShow = false;
        }
        _this4.$message.success("".concat(type === 'show' ? '显示' : '状态', "\u66F4\u65B0\u6210\u529F"));
        _this4.getList();
      }).catch(function () {
        if (type === 'show') {
          row.isShow = !row.isShow;
        } else {
          row.status = !row.status;
        }
      });
    },
    // 关联店铺 - 跳转到编辑页面的关联店铺tab
    handleBindMerchant: function handleBindMerchant(row) {
      this.$router.push(this.areaPath("/area/create/".concat(row.id, "?tab=2")));
    },
    // 导出
    handleExport: function handleExport() {
      this.$message.info('导出功能待实现');
    },
    // Treeselect normalizer
    normalizer: function normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children
      };
    }
  }
};